(() => {
  const rootSelector = '[data-shop-all-comparison]';

  class ShopAllComparison {
    constructor(root) {
      this.root = root;
      this.slots = Array.from(root.querySelectorAll('[data-comparison-slot]'));
      this.selectedProducts = new Map();
      this.productCount = this.slots[0]?.querySelectorAll('[data-comparison-product]').length || 0;

      this.slots.forEach((slot) => {
        this.selectedProducts.set(slot.dataset.comparisonSlot, slot.dataset.initialProduct);

        slot.querySelectorAll('[data-comparison-select]').forEach((select) => {
          select.addEventListener('change', (event) => {
            this.selectProduct(event.currentTarget.dataset.comparisonSlotSelect, event.currentTarget.value);
          });
        });
      });

      this.render();
    }

    selectProduct(slotId, productId) {
      const slot = this.slots.find((item) => item.dataset.comparisonSlot === slotId);
      const matchingProduct = slot?.querySelector(`[data-comparison-product="${CSS.escape(productId)}"]`);

      if (!slot || !matchingProduct) return;

      this.selectedProducts.set(slotId, productId);
      this.render();
    }

    render() {
      this.slots.forEach((slot) => {
        const slotId = slot.dataset.comparisonSlot;
        const selectedProduct = this.selectedProducts.get(slotId);
        const otherSelection = Array.from(this.selectedProducts.entries()).find(([key]) => key !== slotId)?.[1];

        slot.querySelectorAll('[data-comparison-product]').forEach((card) => {
          card.hidden = card.dataset.comparisonProduct !== selectedProduct;
        });

        slot.querySelectorAll('[data-comparison-select]').forEach((select) => {
          select.value = selectedProduct;

          Array.from(select.options).forEach((option) => {
            option.disabled = this.productCount > 1 && option.value === otherSelection;
          });
        });
      });
    }
  }

  const initializeComparisons = (scope = document) => {
    const roots = [];

    if (scope.matches?.(rootSelector)) roots.push(scope);
    roots.push(...scope.querySelectorAll(rootSelector));

    roots.forEach((root) => {
      if (!root.comparisonController) root.comparisonController = new ShopAllComparison(root);
    });
  };

  initializeComparisons();

  if (!window.shopAllComparisonEventsBound) {
    document.addEventListener('shopify:section:load', (event) => initializeComparisons(event.target));
    window.shopAllComparisonEventsBound = true;
  }
})();
